import { useUpdateUserInfo } from "@/features/user/hooks/use-update-user-info";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import React, {useState}  from "react";
import { useLoginContext } from "@/features/auth/contexts/login-context";
import { SimpleForm } from "@/shared/components/text-box/simple-form";


interface Props {
  onTapCloseModal: () => void;
  onTapCompleteModal: () => void;
}

// ログイン画面で利用している「パスワードを忘れた方、お困りの方はこちら」モーダル
export const UpdateUserInfoModal = ({ onTapCloseModal, onTapCompleteModal }: Props) => {
  const {
    onClickUpdate,
    onChangeUserName,
  } = useUpdateUserInfo({ onTapCompleteModal });

  const {
    userName,
    setUserName,
  } = useLoginContext();

  // 変更ボタンに付与するID
  const updateUserNameButton = "update_user_name_button";
  
  //変更前のユーザー名を保持するためのstate
  const [originalUserName] = useState(userName);
  
  return (
    <BasePageModal
      title="ユーザー名の変更"
      className="md-user-profile"
      handleClose={() => {
        onTapCloseModal();
        setUserName(originalUserName);// 変更前のユーザー名に戻す
      }}
      bottomChildren={
        <BaseRoundButton
          buttonText="ユーザー名を変更"
          onClick={() => {
            onClickUpdate(
              userName.slice(0, 50).trim(), // ユーザ名
              undefined, // お知らせメール配信
            );
          }}
          id={updateUserNameButton}
          loadingNegative={true}
          isActive={userName !== undefined && userName !== ""}
        />
      }
      disableOverlayClose={true}
    >
      <h2>現在のご登録の内容</h2>
      <dl>
        <SimpleForm
          title="ユーザー名"
          onChange={onChangeUserName}
          placeholder="ユーザー名"
          initialValue={userName}
          descriptionType={true}
          labelEnable={true}
        />
      </dl>
    </BasePageModal>
  );
};
